window.FontAwesomeConfig = {
  autoReplaceSvg: false
};
